module.exports = __webpack_public_path__ + "static/media/3.c5649d7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/magazine/3.jpg
// module id = 56
// module chunks = 0